import { EnvelopeRecipientStatus, StakeholderType } from '@urbanx/agx-ui-components';
import {
  type EnvelopeSubmissionRecipient,
  type UploadedDocument,
  UploadedDocumentDocumentType,
} from '@urbanx/agx.campaigns.client';

export const getContractExchangeDownloadDocuments = (documents: UploadedDocument[] = []) => {
  const contract = [
    UploadedDocumentDocumentType.SignedContract,
    UploadedDocumentDocumentType.SalesContract,
    UploadedDocumentDocumentType.ContractExchange,
  ]
    .map((type) =>
      documents.find((document) => document.documentType === type && document.containerFilePath)
    )
    .find((document) => document !== undefined);

  return [
    contract,
    documents.find(
      (document) => document.documentType === UploadedDocumentDocumentType.AuthorityToExchange
    ),
    documents.find(
      (document) => document.documentType === UploadedDocumentDocumentType.SalesAdvice
    ),
    documents.find(
      (document) => document.documentType === UploadedDocumentDocumentType.MergedContractExchange
    ),
  ].filter((document): document is UploadedDocument => !!document?.containerFilePath);
};

export const allSigned = (
  recipients: EnvelopeSubmissionRecipient[],
  stakeHolderType: StakeholderType
) => {
  const stakeHolders = recipients.filter((x) => x.stakeholderType === stakeHolderType);
  const validStatuses = [EnvelopeRecipientStatus.Signed, EnvelopeRecipientStatus.Complete];
  return stakeHolders.length > 0 && stakeHolders.every((x) => validStatuses.includes(x.status!));
};
